import styled from '@emotion/styled';
import { Flex } from 'antd';

export const Container = styled.div<{ $bgImage: string }>`
  color: #f2f2f2;
  min-height: 100vh;
  display: grid;
  grid-template-rows: 1fr auto 1fr;
  background-image: url(${(props) => props.$bgImage});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  padding: 6rem;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    padding: 4rem;
  }

  @media (max-width: 480px) {
    gap: 1rem;
    padding: 3rem 4rem;
    min-height: 100vh;
    background-attachment: scroll;
  }
`;

export const Logo = styled.img`
  height: 48px;
  width: auto;
  object-fit: contain;

  @media (max-width: 768px) {
    height: 40px;
  }

  @media (max-width: 480px) {
    height: 28px;
  }
`;

export const Title = styled.h1`
  font-size: 3rem;
  line-height: 1.3;
  margin: 0;
  font-weight: 600;

  @media (max-width: 1200px) {
    font-size: 2.5rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.625rem;
    line-height: 1.25;
  }
`;

export const Description = styled.p`
  font-size: 1rem;
  line-height: 1.8;
  max-width: 45%;
  margin: 0;

  @media (max-width: 1200px) {
    max-width: 50%;
  }

  @media (max-width: 768px) {
    font-size: 0.95rem;
    max-width: 100%;
    margin-top: 1.5rem;
    text-align: center;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
    line-height: 1.5;
    margin-top: 0;
  }
`;

export const TopSection = styled(Flex)`
  justify-content: end;
  gap: 2rem;

  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    gap: 1rem;
    margin-bottom: 2rem;
  }
`;

export const BottomSection = styled(Flex)`
  width: 100%;
  margin-bottom: 0;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 0;
  }

  @media (max-width: 480px) {
    align-items: center;
    margin-bottom: 0;
    gap: 1rem;
  }
`;

export const LogoContainer = styled(Flex)`
  justify-content: end;

  @media (max-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const ButtonContainer = styled(Flex)`
  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
    gap: 12px;
  }
`;
